/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService
 */

export const fetchRpc = {
  serviceName: 'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'fetch',
  auth: 'app',
  fingerprint: 'mdFQJXEaVZ-2M9rn0zAPFcYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchAllForUserRpc = {
  serviceName: 'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'fetchAllForUser',
  auth: 'app',
  fingerprint: 'qNzI1F3FmcBKgJ7KIGBXw8YHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};